import React, { useCallback } from "react";
import { SelectFromReference } from "src/components/SelectFromReference";
import { makeFieldOptions } from "src/common/makeFieldOptions";
import { SelectProps } from "antd";
import { ZUid } from "src/types/zUid";
import { loadObjectAttrinbutesAll } from "src/pages/ManagementPage/objectsApi";
import { filterBacklinkCandidateAttrs } from "./filterBacklinkCandidateAttrs";

type PropsSelectBacklinkAttribute = SelectProps & {
  targetObjectId?: ZUid;
  currentObjectId: ZUid;
  attrTypesDict: Record<number, string>;
  excludeAttrId?: ZUid;
};

export const SelectBacklinkAttribute: React.FC<
  PropsSelectBacklinkAttribute
> = ({
  targetObjectId,
  currentObjectId,
  attrTypesDict,
  excludeAttrId,
  ...props
}) => {
  const loader = useCallback(async () => {
    if (!targetObjectId) return [];
    const attrs = await loadObjectAttrinbutesAll(targetObjectId);
    return makeFieldOptions(
      filterBacklinkCandidateAttrs(
        attrs,
        currentObjectId,
        attrTypesDict,
        excludeAttrId,
      ),
    );
  }, [attrTypesDict, currentObjectId, excludeAttrId, targetObjectId]);

  return (
    <SelectFromReference
      loader={loader}
      {...props}
      optionFilterProp="filterProp"
      showSearch
      allowClear
    />
  );
};
